import { OneLinkTargetScreens } from "~/types/base";
import { useState } from "#imports";

export default function () {
  const getLinkToApp = (id: number, isFake: boolean = false): string => {
    const { oneLink } = useAppConfig();
    const source = useCookie('_fm_source').value ?? useState('_fm_source').value;
    const campaign = useCookie('_fm_campaign').value ?? useState('_fm_campaign').value;
    const baseUrl = ref('');

    if (source && source === 'reddit') {
      baseUrl.value = oneLink.redditUrl
    } else {
      baseUrl.value = isFake ? oneLink.fakeBooksUrl : oneLink.baseUrl;
    }

    const url: URL = new URL(baseUrl.value);

    url.searchParams.append('deep_link_sub2', id.toString());
    url.searchParams.append('deep_link_value', OneLinkTargetScreens.BookOnboarding);

    return url.href;
  }

  return {
    getLinkToApp
  }
}